/** Studio page assets use the project's Blob store (private by default). */
export const STUDIO_BLOB_ACCESS = "private" as const;

export function getStudioAssetPublicUrl(pathname: string): string {
  const segments = pathname
    .split("/")
    .filter(Boolean)
    .map(encodeURIComponent)
    .join("/");
  return `/api/studio/files/${segments}`;
}

export function studioAssetPathnameFromPublicUrl(url: string): string | null {
  const prefix = "/api/studio/files/";
  if (!url.startsWith(prefix)) {
    return null;
  }

  try {
    const pathname = url
      .slice(prefix.length)
      .split("/")
      .filter(Boolean)
      .map((segment) => decodeURIComponent(segment))
      .join("/");
    return isStudioAssetPathname(pathname) ? pathname : null;
  } catch {
    return null;
  }
}

export function isStudioAssetPathname(pathname: string): boolean {
  return pathname.startsWith("studio/");
}
